import axios from "axios";
import {
  FETCH_DATA_FAILURE,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
} from "../store/actionTypes";

export const fetchDataRequest = (api) => ({
  type: FETCH_DATA_REQUEST,
  api,
});

export const fetchDataSuccess = (api, data) => ({
  type: FETCH_DATA_SUCCESS,
  api,
  payload: data,
});

export const fetchDataFailure = (api, error) => ({
  type: FETCH_DATA_FAILURE,
  api,
  payload: error,
});

const createConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const fetchData = (url, api, body = null) => {
  return (dispatch) => {
    dispatch(fetchDataRequest(api));

    const config = createConfig();

    let request;

    if (body) {
      request = axios.post(url, body, config);
    } else {
      request = axios.get(url, config);
    }

    request
      .then((response) => {
        const Data = response.data;
        dispatch(fetchDataSuccess(api, Data));
      })
      .catch((error) => {
        dispatch(fetchDataFailure(api, error));
      });
  };
};

// Generic function to fetch data for any given API
export const createFetchAction = (api) => {
  return (url) => (dispatch) => {
    fetchData(url, api)(dispatch);
  };
};

// Action to fetch and handle POST requests
export const createPostAction = (api) => {
  return (url, body) => (dispatch) => {
    fetchData(url, api, body)(dispatch);
  };
};

// Example usage:
export const fetchTopFiveProduct = createFetchAction("topFiveProduct");
export const fetchModelDetails = createFetchAction("modelDetails");
export const postFeedback = createPostAction("feedbackDetails");